import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import request from '../../../../request';
import DinamicRoute from '../../Core/DinamicRoute';

/**
 * DynamicModuleResolver — Catch-all component that resolves 
 * database-driven modules based on the current URL path.
 */
const DynamicModuleResolver = ({ ipserv }) => {
    const location = useLocation();
    const [module, setModule] = useState(null);
    const [loading, setLoading] = useState(true);

    // Extract the active sub-path
    const activeSubPath = location.pathname.split('/Core/SuperAdmin/')[1] || '';

    useEffect(() => {
        const profile = (() => {
            try { return JSON.parse(localStorage.getItem('dm_admin')) || {}; }
            catch { return {}; }
        })();

        if (profile.ProfileId) {
            setLoading(true);
            request.Get(ipserv + `superadmin/menu/${profile.ProfileId}`, {}, r => {
                if (r.success) {
                    const findItem = (items) => {
                        for (const item of items) {
                            const itemId = String(item.ModuleKey || item.id);
                            if (itemId === activeSubPath) return item;
                            const sub = [...(item.items || []), ...(item.menus || [])];
                            const found = findItem(sub);
                            if (found) return found;
                        }
                        return null;
                    };

                    const found = findItem(r.data || []);
                    setModule(found);
                }
                setLoading(false);
            });
        }
    }, [activeSubPath, ipserv]);

    if (loading) return <div className="p-4 text-muted">Cargando módulo...</div>;
    if (!module) return <div className="p-4 text-muted">Módulo no encontrado.</div>;

    let params = {};
    try { params = module.autQParams ? JSON.parse(module.autQParams) : {}; } catch (e) { }

    return (
        <DinamicRoute
            key={module.id || module.ModuleId}
            QueId={module.queryId || module.ModuleQueryId}
            Title={module.autQTitle || module.label || module.ModuleLabel}
            params={params}
            ipserv={ipserv}
        />
    );
};

export default DynamicModuleResolver;
